import { memo } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCookieConsent } from '@/hooks/useCookieConsent';

const CookieBanner = memo(function CookieBanner() {
  const { showBanner, acceptAll, rejectAll, setShowModal } = useCookieConsent();
  
  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6"
        >
          <div className="max-w-3xl mx-auto bg-card/95 backdrop-blur-sm border border-border/50 rounded-xl shadow-soft p-4">
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
              {/* Content */}
              <div className="flex items-center gap-2.5 flex-1 min-w-0">
                <Cookie className="w-4 h-4 text-gold shrink-0" />
                <p className="text-xs text-muted-foreground">
                  Vi använder cookies för att förbättra upplevelsen.{' '}
                  <Link to="/cookies" className="text-primary hover:underline">
                    Läs mer
                  </Link>
                </p>
              </div>
              
              {/* Buttons */}
              <div className="flex gap-2 shrink-0">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setShowModal(true)}
                  className="text-xs h-8 px-3"
                >
                  <Settings className="w-3.5 h-3.5 mr-1.5" />
                  Anpassa
                </Button>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={rejectAll}
                  className="text-xs h-8 px-3"
                >
                  Avvisa
                </Button>
                <Button
                  variant="cta"
                  size="sm"
                  onClick={acceptAll}
                  className="text-xs h-8 px-3"
                >
                  Acceptera
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default CookieBanner;
